import { createSelector } from 'reselect';

export const selectAPIKeys = (state) => state.apikey.list;
export const selectActualAPIKeyObject = (state) => state.apikey.actualKey;
